import React from "react";
import { sections } from "..";
import Link from "next/link";
import clsx from "clsx";
import Typography from "@sendsprint/ui-react/components/typography";

interface Props {
  hash: string;
  handleSetHash: (arg: string) => void;
}

const DesktopAside = ({ hash, handleSetHash }: Props) => {
  return (
    <div className="ss:hidden ss:md:block ss:sticky ss:top-25">
      {sections.map((item) => {
        const isActive = decodeURIComponent(hash).includes(item);
        return (
          <Link
            href={`#${item}`}
            onClick={() => handleSetHash(item)}
            className={clsx("ss:py-2 ss:pl-4 ss:border-l-2 ss:block", {
              "ss:border-primary1-500 ss:font-semibold": isActive,
              "ss:border-transparent ss:opacity-60": !isActive,
            })}
            key={item}
          >
            <Typography>{item}</Typography>
          </Link>
        );
      })}
    </div>
  );
};

export default DesktopAside;
